import { createFileRoute } from "@tanstack/react-router"

import { SettingsOverview } from "@/features/settings/components/settings-overview"

export const Route = createFileRoute(
  "/$organisation/_authenticated/_organisation/settings/"
)({ component: SettingsOverview })
